import {
  type Notification as NotificationData,
  notificationApi,
  type NotificationListParams,
} from '@mathflat/domain/Notification'
import type { NotificationCTA } from 'src/dto'
import { Notification, NotificationColl } from 'src/dto'
import ExtendedMap from 'src/models/ExtendedMap'

type NotificationPartitionKey = { partitionKey: NotificationData['partitionKey'] }

export const notificationController = {
  fetchItems: async ({
    partitionKey,
    params,
  }: NotificationPartitionKey & { params: Omit<NotificationListParams, 'partitionKey'> }) => {
    const { result, hasBefore } = await notificationApi.getNotifications({
      partitionKey,
      ...params,
    })
    const notificationArr = result.map((notification) => new Notification(notification))

    return {
      hasBefore,
      notificationColl: new NotificationColl(ExtendedMap.fromArr(notificationArr, 'sortKey')),
    }
  },
  fetchUnreadCount: ({ partitionKey }: NotificationPartitionKey) =>
    notificationApi.getUnreadNotificationCount(partitionKey),
  readItem: ({
    partitionKey,
    params,
  }: NotificationPartitionKey & { params?: { sortKey: NotificationData['sortKey'] } }) => {
    notificationApi.readNotifications(partitionKey, params?.sortKey)
  },
  deleteCTA: ({
    partitionKey,
    sortKey,
    action,
  }: NotificationPartitionKey & {
    sortKey: NotificationData['sortKey']
    action: NotificationCTA
  }) => {
    notificationApi.deleteNotificationCta(partitionKey, sortKey, action)
  },
}
